import {set} from 'lodash';
import map from 'lodash/map';
import moment from 'moment';
import React from 'react';
import {connect} from 'react-redux';
import swal from 'sweetalert2';
import {
  createJersey,
  getJerseys,
  updateJerseyInfos,
} from '../../../actions/entities/jerseys';
import UpdateJersey from '../UpdateJersey';
import {uploadPicture} from '../uploadPicture';
import './index.css';

class JerseysList extends React.Component {
  state = {
    updateJerseyOpen: false,
    jerseyInfo: null,
    isEdit: false,
  };

  componentDidMount() {
    const {dispatch} = this.props;
    dispatch(getJerseys(), null, this.onError);
  }

  onError = error => {
    swal({
      title: `Oops...`,
      type: 'error',
      html:
        `Something went wrong:<br/>${error}<br/>` +
        `<pre><code>${JSON.stringify(error, undefined, 4)}</code></pre>`,
    });
  };

  onClickEdit(jerseyInfo) {
    this.setState({
      updateJerseyOpen: true,
      jerseyInfo,
      isEdit: true,
    });
  }

  onChangeInput = (value, key) => {
    this.setState({jerseyInfo: set(this.state.jerseyInfo, key, value)});
  };

  updateInfos = () => {
    const {dispatch} = this.props;
    const {jerseyInfo} = this.state;
    const onSuccess = () => {
      swal({
        title: 'Updated !',
        type: 'success',
      });
      dispatch(getJerseys());
    };
    dispatch(updateJerseyInfos(jerseyInfo, onSuccess, this.onError));
  };

  submitCreation = () => {
    const {dispatch} = this.props;
    const {jerseyInfo} = this.state;
    const onSuccess = () => {
      swal({
        title: 'Created !',
        type: 'success',
      });
      this.setState({jerseyInfo: null, updateJerseyOpen: false});
      dispatch(getJerseys());
    };
    dispatch(createJersey(jerseyInfo, onSuccess, this.onError));
  };

  render() {
    const {jerseys} = this.props;
    const {updateJerseyOpen, jerseyInfo, isEdit} = this.state;

    return (
      <div id="JerseysList">
        <section className="content">
          <div className="row">
            <div className="row">
              <div className="col-md-6">
                <div className="box box-default">
                  <div className="box-header with-border">
                    <h3 className="box-title pull-left">
                      <i className="fa fa-plus-circle" /> Jerseys List
                    </h3>
                  </div>
                  <div className="table-fixed-height">
                    <div className="text-center">
                      <button
                        className="btn btn-success m-3"
                        onClick={() =>
                          this.setState({
                            updateJerseyOpen: true,
                            jerseyInfo: {
                              localization: {
                                'fr-FR': {name: '', description: ''},
                                'es-ES': {name: '', description: ''},
                                'en-GB': {name: '', description: ''},
                              },
                            },
                            isEdit: false,
                          })
                        }>
                        Create Jersey
                      </button>
                    </div>
                    <table className="table table-responsive table-striped">
                      <thead>
                        <tr>
                          <th />
                          <th>ID</th>
                          <th>NAME</th>
                          <th>CREATION</th>
                          <th />
                        </tr>
                      </thead>
                      <tbody>
                        {map(jerseys.data, jersey => {
                          const selected =
                            jerseyInfo && jerseyInfo.id === jersey.id;
                          return (
                            <tr
                              className={selected && 'rowSelected'}
                              key={jersey.id}>
                              <td>
                                <img
                                  style={{width: '30px'}}
                                  src={`${
                                    jersey.imageUrl
                                  }?nocache=${new Date()}`}
                                  alt=""
                                />
                              </td>
                              <td>{jersey.code}</td>
                              <td>
                                {(jersey.localization &&
                                  jersey.localization['fr-FR'] &&
                                  jersey.localization['fr-FR'].name) ||
                                  '-'}
                              </td>
                              <td>
                                {moment(jersey.startDate).format('DD/MM/YY')}
                              </td>
                              <td>
                                {!selected && (
                                  <button
                                    className="btn btn-warning"
                                    onClick={() => this.onClickEdit(jersey)}>
                                    Edit
                                  </button>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              {updateJerseyOpen && (
                <UpdateJersey
                  data={jerseyInfo || {}}
                  edit={isEdit}
                  editJersey={this.updateInfos}
                  submit={this.submitCreation}
                  onUpload={file =>
                    this.props.dispatch(
                      uploadPicture(
                        file,
                        imageUrl => this.onChangeInput(imageUrl, 'imageUrl'),
                        'jersey',
                      ),
                    )
                  }
                  onChangeInput={this.onChangeInput}
                />
              )}
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default connect(
  state => ({
    jerseys: state.app.jerseys.list,
  }),
  dispatch => ({dispatch}),
)(JerseysList);



// WEBPACK FOOTER //
// ./src/pages/Jerseys/List/index.js